import { render, staticRenderFns } from "./AdminMetaFieldsEdit.vue?vue&type=template&id=6d39fa0b&scoped=true&"
import script from "./AdminMetaFieldsEdit.vue?vue&type=script&lang=js&"
export * from "./AdminMetaFieldsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d39fa0b",
  null
  
)

export default component.exports